import {
  IubendaProvider as IubendaProviderComponent,
  IubendaCookieSolutionBannerConfigInterface,
  useIubenda,
} from '@mep-agency/next-iubenda';
import { usePostHog } from 'posthog-js/react';
import { useEffect } from 'react';
import { useSnapshot } from 'valtio';

import store from 'common/middleware/store';

const iubendaBannerConfig: IubendaCookieSolutionBannerConfigInterface = {
  siteId: 3976585,
  cookiePolicyId: 51855117,
  lang: 'en',
};

export const IubendaProvider = function IubendaProvider({ children }: { children: React.ReactNode }) {
  const { isDevEnv } = useSnapshot(store);

  if (isDevEnv) {
    return children;
  }

  return (
    <IubendaProviderComponent bannerConfig={iubendaBannerConfig}>
      <PostHogControl />
      {children}
    </IubendaProviderComponent>
  );
};

const PostHogControl = () => {
  const { userPreferences } = useIubenda();
  const posthog = usePostHog();

  useEffect(() => {
    if (location.hostname.includes("qa")) {
      return;
    }

    if (userPreferences?.gdprPurposes?.measurement && posthog?.has_opted_out_capturing()) {
      posthog?.opt_in_capturing();
    } else if (!userPreferences?.gdprPurposes?.measurement && posthog?.has_opted_in_capturing()) {
      posthog?.opt_out_capturing();
    }
  }, [userPreferences?.gdprPurposes?.measurement, posthog]);

  return null;
};
